<template>
  <v-chip
    v-if="user"
    small
    class="chat-member"
    v-bind:class="{ typing: typing }"
  >
    {{ user.friendlyName }}
    {{ typing ? "..." : null }}
  </v-chip>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
  name: "ChatMember",
  props: ["participant", "typing"],
  data() {
    return {
      user: null
    };
  },
  async mounted() {
    this.user = await this.participant.getUser();
  }
});
</script>
<style>
.chat-member {
  margin: 0 1px 1px 0;
}
.member.typing {
  color: dodgerblue;
}
</style>
